"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheUniversalMetaRuntime() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const openAppStore = () => {
    window.open("https://apps.apple.com/us/app/barndesk/id6768716555", "_blank", "noopener,noreferrer");
  };
  const openGooglePlay = () => {
    window.open("https://play.google.com/store/apps/details?id=com.barndesk.app", "_blank", "noopener,noreferrer");
  };
  return <section data-section-id="221782" id="farmmanagementhero" className="bg-background text-foreground relative overflow-hidden min-h-[80vh] flex flex-col items-center justify-center pt-24 pb-16">
      {/* Atmospheric background */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,var(--color-accent)_0%,transparent_70%)] opacity-40"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-10 blur-[100px]"></div>
        <img src="https://thebarndesk.com/wp-content/uploads/2026/05/barndesk-app-icon-1024.png" alt="" aria-hidden="true" className="w-[600px] max-w-[80vw] h-auto object-contain opacity-10" style={{
        filter: "drop-shadow(0 0 40px var(--color-primary))"
      }} />
      </div>
      {/* Foreground */}
      <div ref={ref} className={`container relative z-10 mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Badge variant="outline" className="mb-8 border-primary/30 text-primary bg-primary/5 backdrop-blur-md px-4 py-1.5 text-sm rounded-lg shadow-sm">
          <span className="relative flex h-2 w-2 mr-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
            <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
          </span>
          Built by a Farmer, for Farmers
        </Badge>
        <h1 className="font-default text-5xl md:text-6xl lg:text-7xl leading-[1.05] font-bold tracking-tight mb-8 text-primary max-w-5xl drop-shadow-sm">
          Six things every family farm tracks.
          <br />
          One app to keep them straight.
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-foreground/80 max-w-3xl mb-6 font-sans font-normal leading-relaxed">
          Animals, breeding and pedigrees, chores, inventory, equipment, and the Schedule F and USDA paperwork that comes with all of it. BarnDesk replaces the notebooks, phone photos, spreadsheets, and shoeboxes that scatter farm records across the farm.
        </p>
        <p className="font-serif italic text-primary text-lg md:text-xl mb-10">
          Less paperwork, more pasture.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <button type="button" onClick={openAppStore} className="inline-flex items-center gap-3 h-12 px-5 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity">
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[10px] uppercase tracking-wide opacity-80">Download on the</span>
              <span className="text-base font-semibold">App Store</span>
            </span>
          </button>
          <button type="button" onClick={openGooglePlay} className="inline-flex items-center gap-3 h-12 px-5 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity">
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[10px] uppercase tracking-wide opacity-80">Get it on</span>
              <span className="text-base font-semibold">Google Play</span>
            </span>
          </button>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          Free for up to 10 animals. No credit card to start.
        </p>
      </div>
    </section>;
}